import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { UIProvider } from '@vatman/ui';

/** The design system's provider with the texts in the person's language. */
export function AppUIProvider({ children }: { children: ReactNode }) {
  const { t } = useTranslation();
  return <UIProvider labels={{ close: t('common.close') }}>{children}</UIProvider>;
}
